// Fonte unica do workspace ativo, sincronizada entre Context e interceptor axios.
// WorkspaceContext chama setActiveWorkspaceId(id) ao trocar; interceptor chama getActiveWorkspaceId().

let _activeWorkspaceId: number | null = null;

export function setActiveWorkspaceId(id: number | null): void {
  _activeWorkspaceId = id;
  if (id === null) {
    localStorage.removeItem("workspace_id");
  } else {
    localStorage.setItem("workspace_id", String(id));
  }
}

export function getActiveWorkspaceId(): number | null {
  if (_activeWorkspaceId !== null) return _activeWorkspaceId;
  const stored = localStorage.getItem("workspace_id");
  if (stored) {
    _activeWorkspaceId = Number(stored);
    return _activeWorkspaceId;
  }
  return null;
}
